import { bodyStore } from "@/store/bodyStore";
import { BodyPart, PartName } from "@/types/design";
import { selectingPartStore } from "@/store/partsStore";
import { previewPartsStore } from "@/store/previewPartsStore";

// パーツ コンポーネントで使うロジックを提供します。
export default function usePart() {
	const { body, updateBody } = bodyStore();
	const { setSelectingPart } = selectingPartStore();
	const { previewParts } = previewPartsStore();

	// パーツクリック時の処理
	const onPartClick = (partId: string, partName: PartName) => {
		// 選択中のパーツを管理する
		// パーツがすでに選択された状態でクリックされたら解除する
		const targetPart = body.find((m: BodyPart) => m.partName === partName);
		const isPartDeselected = partId === targetPart?.partId;
		const updatedSelectringPart = {
			partId: isPartDeselected ? undefined : partId,
			partName,
		};
		setSelectingPart(updatedSelectringPart);
		// クリックされたパーツおよびIdの設定をする
		const newBody = body.map((part: BodyPart) => {
			// パーツがすでに選択された上でクリックされた場合は選択を解除する
			if (part.partName === partName) {
				const index = Number(partId) - 1;
				const selectedPart = previewParts[partName].at(index)!.part;
				return {
					...part,
					partId: isPartDeselected ? undefined : partId,
					partComponent: isPartDeselected ? undefined : selectedPart,
				};
			}
			return part;
		});
		updateBody(newBody);
	};

	return {
		body,
		onPartClick,
	};
}
